import ME from "../../assets/me-about.jpg";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";
import "./About.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function About() {
  return (
    <section id="about">
      <h5>Get to Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-img">
            <LazyLoadImage  effect="blur"src={ME} alt="about-me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>3+ years working experience</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>30+ Projects</small>
            </article>
          </div>
          <p>
            Computer engineering graduate from AASTU with over 3+ years of web
            development experience. I possess a strong aptitude for learning and
            collaborating in rapidly changing environments and diverse teams. My
            expertise extends across a wide range of computer languages and
            frameworks, complemented by a profound understanding of website
            design, development, and maintenance principles. Through diverse
            work experience, I have acquired invaluable real-world skills,
            allowing me to excel in practical application scenarios.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
}

export default About;
